import React from "react";

import LeadInformation from "../lead/LeadInformation";
import CallTab from "./tabview/CallTab";
import MeetingTab from "./tabview/MeetingTab";
import DocumentTab from "./tabview/DocumentTab";
import SmsTab from "./tabview/SmsTab";
import EmailTab from "./tabview/EmailTab";
import NoteTab from "./tabview/NoteTab";
import SalesOrderTab from "./tabview/SalesOrderTab";
import ContactTab from "./tabview/ContactTab";
import Const from "../../util/Constants";
import Util from "../../util/Util";
import WhatsAppTab from "./tabview/WhatsAppTab";
import PropertyTab from "./tabview/PropertyTab";

class TabView extends React.Component {
  render() {
    const activeTab = this.props.activeTab;
    const staticTab = this.props.staticTab;
    return (
      <span className={`alert alert-dark nav-item nav-link ${activeTab === staticTab ? 'active' : ''}`} id="nav-home-tab"
        data-toggle="tab" role="tab" aria-controls="nav-home" aria-selected="true"
        onClick={() => this.props.onTabClick(staticTab)}>
        {staticTab === 'view' ? 'Details' :
          `${this.props.model[staticTab].model_name} (${this.props.count[staticTab] ? this.props.count[staticTab] : 0})`}
      </span>
    );
  }
}

class PannelTab extends React.Component {
  render() {
    const tab = this.props.activeTab;
    return (
      <div className={`tab-pane fade ${tab === 'view' ? 'show active in' : ''}`}>
        <div className="row">
          <div className="col-md-12">
            <LeadInformation model={this.props.model.lead} lead={this.props.lead} />
          </div>
        </div>
      </div>
    );
  }
}

class TabPanelView extends React.Component {

  static View = 'view';
  static Call = 'call';
  static Meeting = 'meeting';
  static Document = 'document';
  static Sms = 'sms';
  static Email = 'email';
  static Service = 'service';
  static Quote = 'quote';
  static SalesOrder = 'sales_order';
  static Contact = 'contact';
  static WhatsApp = 'whatsapp';
  static Property = 'property';

  constructor(props) {
    super(props);
    this.CallList = Util.isAllow(this.props.model.call.permission, Const.PermView);
    this.MeetList = Util.isAllow(this.props.model.meeting.permission, Const.PermView);
    this.DocList = Util.isAllow(this.props.model.document.permission, Const.PermView);
    this.PropertyList = Util.isAllow(this.props.model.property.permission, Const.PermView);
    this.SmsList = Util.isAllow(this.props.model.sms.permission, Const.PermView);
    this.EmailList = Util.isAllow(this.props.model.email.permission, Const.PermView);
    this.NoteList = Util.isAllow(this.props.model.note.permission, Const.PermView);
    this.SalesList = Util.isAllow(this.props.model.sales_order.permission, Const.PermView);
    this.ContactList = Util.isAllow(this.props.model.contact.permission, Const.PermView);
    this.WhatsAppList = Util.isAllow(this.props.model.whatsapp.permission, Const.PermView);

    let activetab = TabPanelView.View;
    if (this.props.View) { activetab = TabPanelView.View; }
    else if (this.CallList) { activetab = TabPanelView.Call; }
    else if (this.MeetList) { activetab = TabPanelView.Meeting; }
    else if (this.PropertyList) { activetab = TabPanelView.Property; }
    else if (this.DocList) { activetab = TabPanelView.Document; }
    else if (this.SmsList) { activetab = TabPanelView.Sms; }
    else if (this.EmailList) { activetab = TabPanelView.Email; }
    else if (this.SalesList) { activetab = TabPanelView.SalesOrder; }
    else if (this.ContactList) { activetab = TabPanelView.Contact; }
    else if (this.WhatsAppList) { activetab = TabPanelView.WhatsApp; }
    else { activetab = TabPanelView.View; }

    this.state = {
      activeTab: activetab, call: 0, meeting: 0, document: 0, sms: 0, email: 0, property: 0,
      sales_order: 0, quote: 0, contact: 0, whatsapp: 0
    };
  }

  onTabClick = view => this.setState({ ...this.state, activeTab: view });

  onCount = (view, count) => {
    if(view === "property" && count && this.props?.onPropertyCount) {
      this.props.onPropertyCount(count)
    }
    let tmp = this.state;
    tmp[view] = count;
    this.setState({ ...this.state, tmp });
  };

  render() {
    const tab = this.state.activeTab;
    return (
      <div className="row " id="cources">
        <div className="col-md-12">
          <div className="content-box">
            <nav className="project-tab">
              <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                {this.props.View ? <TabView staticTab="view" activeTab={tab} count={this.state}
                  onTabClick={this.onTabClick} model={this.props.model} /> : null}
                {this.CallList ? <TabView staticTab="call" activeTab={tab} count={this.state}
                  onTabClick={this.onTabClick} model={this.props.model} /> : null}
                {this.MeetList ? <TabView staticTab="meeting" activeTab={tab} count={this.state}
                  onTabClick={this.onTabClick} model={this.props.model} /> : null}
                {this.PropertyList ? <TabView staticTab="property" activeTab={tab} count={this.state}
                  onTabClick={this.onTabClick} model={this.props.model} /> : null}
                {this.WhatsAppList ? (<TabView staticTab="whatsapp" activeTab={tab}
                  count={this.state} onTabClick={this.onTabClick} model={this.props.model} />) : null}
                {this.SmsList ? <TabView staticTab="sms" activeTab={tab} count={this.state}
                  onTabClick={this.onTabClick} model={this.props.model} /> : null}
                {this.EmailList ? <TabView staticTab="email" activeTab={tab} count={this.state}
                  onTabClick={this.onTabClick} model={this.props.model} /> : null}
                {this.NoteList ? <TabView staticTab="note" activeTab={tab} count={this.state}
                  onTabClick={this.onTabClick} model={this.props.model} /> : null}
                {this.DocList ? <TabView staticTab="document" activeTab={tab} count={this.state}
                  onTabClick={this.onTabClick} model={this.props.model} /> : null}
                {this.ContactList ? <TabView staticTab="contact" activeTab={tab} count={this.state}
                  onTabClick={this.onTabClick} model={this.props.model} /> : null}
                {this.SalesList ? <TabView staticTab="sales_order" activeTab={tab} count={this.state}
                  onTabClick={this.onTabClick} model={this.props.model} /> : null}
              </div>
            </nav>

            <div className="tab-content" id="nav-tabContent">
              {this.props.View ? (
                <PannelTab
                  staticTab="view"
                  activeTab={tab}
                  count={this.state}
                  onTabClick={this.onTabClick}
                  model={this.props.model}
                  lead={this.props.lead}
                />
              ) : null}
              {this.CallList ? (
                <CallTab
                  {...this.props}
                  id={this.props.id}
                  type={this.props.type}
                  reload={this.props.reload}
                  edit={this.props.edit}
                  activeTab={this.state.activeTab}
                  onCount={this.onCount}
                />
              ) : null}
              {this.MeetList ? (
                <MeetingTab
                  {...this.props}
                  activeTab={this.state.activeTab}
                  onCount={this.onCount}
                />
              ) : null}
              {this.PropertyList ? (
                <PropertyTab
                  {...this.props}
                  activeTab={this.state.activeTab}
                  onCount={this.onCount}
                />
              ) : null}
              {this.DocList ? (
                <DocumentTab
                  {...this.props}
                  activeTab={this.state.activeTab}
                  onCount={this.onCount}
                />
              ) : null}
              {this.SmsList ? (
                <SmsTab
                  {...this.props}
                  activeTab={this.state.activeTab}
                  onCount={this.onCount}
                />
              ) : null}
              {this.WhatsAppList ? (
                <WhatsAppTab
                  {...this.props}
                  activeTab={this.state.activeTab}
                  onCount={this.onCount}
                />
              ) : null}
              {this.EmailList ? (
                <EmailTab
                  {...this.props}
                  activeTab={this.state.activeTab}
                  onCount={this.onCount}
                />
              ) : null}
              {this.NoteList ? (
                <NoteTab
                  {...this.props}
                  activeTab={this.state.activeTab}
                  onCount={this.onCount}
                />
              ) : null}
              {this.SalesList ? (
                <SalesOrderTab
                  activeTab={this.state.activeTab}
                  onCount={this.onCount}
                  {...this.props}
                />
              ) : null}
              {this.ContactList ? (
                <ContactTab
                  {...this.props}
                  activeTab={this.state.activeTab}
                  onCount={this.onCount}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TabPanelView;
